export default __webpack_public_path__ + "static/damixa-lead-bg--mobile@1x-3b6dd3787dca98cd84fcbb446b1d1d4a.jpg";